import Image from 'app/Components/Shared/Image/image';
import React , {useEffect ,useState} from 'react';
import { connect } from 'react-redux';
import UploadFile from '../../../Shared/UploadFile/UploadFile';
import {dwhReportBuilder , reportsDictionary} from '../reportDwh';
import { getTransitEffectiveDateText , PersonalPricePlanStep } from '../constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import DOMPurify from 'dompurify';
import Config from '../../../../Config';
import {buildUrlAndOpenSameWindow} from '../../../../utilities/StringHelpers/StringHelpers';
import BtnNextStep from '../BtnNextStep';
import { insertAt } from 'app/utilities/StringHelpers/StringHelpers';
import { clearHistory, setCurrentStep } from '../personalPricePlanBlockSlice';
const ConfirmationPage = (props) => {
    const isSingleSubscriber = props.subscribersList.length === 1;
    const parser = new DOMParser();
    const canUploadFile = props.packageDetails?.isBenefitsForSoldiers;
    const title = parser.parseFromString(props.packageDetails?.title, 'text/html').body.textContent;


        const canSelectAnotherSubscriber = (
            props.selectedSubscribers?.length < props.subscribersList?.length || 
            props.personalPricePlan.productsByBan.length > 1
        );
        useEffect(() => {
            if(isSingleSubscriber){
            dwhReportBuilder(reportsDictionary.CHANGE_PRICE_PLAN_SUCCESS_SINGLE);
        }else{
            dwhReportBuilder(reportsDictionary.CHANGE_PRICE_PLAN_SUCCESS);
        }
        return () => {
            props.setCurrentStep(PersonalPricePlanStep.Initial);
            props.clearHistory();
        }
    }, []);


    const getSubscriberNumber = (subscriber) => {
        return <div className='subscriber-number' key={subscriber}>{insertAt(subscriber, 3, '-')}</div>;
    }


    const getPackageTitle = () => {
        return (
        <div className='package-title-container'>
                 <span className='s-title'> המנויים שיעברו לחבילה  </span>
             <span  className='s-title selected-package-title'> {title} :</span>
         </div>  
        );
    }

    return (
        <div className={`success-page-container`}>
            <Image className='success-icon' src={require('../icons/success.svg')} alt='success' />
            <div className='title'>החבילה עודכנה</div>
            {isSingleSubscriber && (
                 <div className='title selected-package-title'>{title}</div>
            )}
             
            
            <div className='s-title gray-text'> {getTransitEffectiveDateText(props.packageDetails?.isImmediatePlan, props.packageDetails.pricePlanMetadata.effectiveDate)} </div>
            
        
            <div className={`subscribers-list-container${canUploadFile ? ' files-upload' : ''}`}>
                {!isSingleSubscriber && getPackageTitle()}
                {canUploadFile ? (
                    <div className='subscribers-list'>
                        {props.selectedSubscribers.map((subscriber) => (
                            <div className='subscriber-item' key={subscriber}>
                                {getSubscriberNumber(subscriber)}
                                <UploadFile
                                    phoneNumber={subscriber}
                                    text={props.packageDetails?.fileUpload?.expandedValue?.[0]?.description?.value || ''}
                                    codeFile={props.packageDetails?.fileUpload?.expandedValue?.[0]?.nameFile?.value || ''}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    props.selectedSubscribers.map((subscriber) => (
                        getSubscriberNumber(subscriber)
                    ))
                )}
            </div>
            

            <div className={`summary s-title gray-text ${isSingleSubscriber && !canUploadFile ? 'single-subscriber' : ''}`}> שלחנו את הסיכום בהודעת SMS למספר {getSubscriberNumber(props.contactNumber)} </div>
           
                <div className='buttons-wrapper'>
                    <BtnNextStep text='לאיזור האישי'
                    canProceed={() => {buildUrlAndOpenSameWindow(Config.lobbyUrl)}}  buttonColor={canSelectAnotherSubscriber ? 'primaryColor' : 'white'} clearHistoryInd={true}/>
                    {canSelectAnotherSubscriber && (
                        <BtnNextStep text='לבחירת מנויים נוספים' nextStep={PersonalPricePlanStep.Initial} buttonColor='white' clearHistoryInd={true}/>
                    )}
                </div>
         </div>
    );
};

const mapStateToProps = (state) => ({
    personalPricePlan: state.personalPricePlan,
    packageDetails: state.personalPricePlan.selectedPackage,
    selectedSubscribers: state.personalPricePlan.selectedSubscribers,
    contactNumber: state.authentication.loginData.userDetails.contactNumber,
    subscribersList: state.personalPricePlan.subscribersList,
});

const mapDispatchToProps = { setCurrentStep, clearHistory};


export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage);